module.exports = "/assets/data/0b11b126fdc23ffbfffcdba3d5e5f1b9-G83.data.json";